// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"514855a7","147":"4692575e","309":"6408be7b","325":"0c687be1","337":"c695a801","352":"46c14ceb","452":"0ff0b6fc","453":"af20e6c5","625":"12aeaf34","855":"baebdd28","885":"bd46ad1c","948":"84d98541","958":"32b0dd3d","980":"25da1da0"}[chunkId] + ".chunk.js";
};